
import { useEffect } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router";
import * as Sentry from "@sentry/react";
import ErrorPage from "./errorPage";
const isDev = import.meta.env.DEV || false;

export default function RouteErrorBoundary() {
    const error = useRouteError();

    let title = "Something went wrong";
    let details = null;

    if (isRouteErrorResponse(error)) {
        title = `${error.status} ${error.statusText || ""}`.trim();
        details = typeof error.data === "string" ? error.data : JSON.stringify(error.data);
    } else if (error instanceof Error) {
        details = error.message;
    } else if (typeof error === "string") {
        details = error;
    }

    // Log once
    useEffect(() => {
        Sentry.withScope((scope) => {
            scope.setTag("boundary", "RouteErrorBoundary");
            if (isRouteErrorResponse(error)) scope.setContext("routeError", error);
            Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
        });
    }, [error]);


    return (
        <ErrorPage>
            {isDev ?
                <>
                    <h2>Route Level: {title}</h2>
                    <pre className="text-xs overflow-auto p-3 bg-white rounded">{details}</pre>
                </> : <></>
            }
        </ErrorPage>
    );
}
